import { useEffect, useState } from 'react'

export function useDebounced<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => clearTimeout(handler)
  }, [delay, value])

  return debouncedValue
}

export function useDebounceFunction() {
  const [handler, setHandler] = useState<NodeJS.Timeout | null>(null)

  const debounce = (callback: (...args: any) => void, delay: number) => {
    if (handler) {
      clearTimeout(handler)
    }
    setHandler(setTimeout(() => callback(), delay))
  }

  return {
    debounce,
  }
}
